import * as types from './types';
import { isServiceError } from '../../utils/errorCodes';

const initialState = {
  postingData: null,
  loadingPostingData: true,
  errorPostingData: false,
  getPostingDataComplete: false,
  qualityData: null,
  loadingQualityData: true,
  errorQualityData: false
};

function previewReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_POSTING_INFO:
      return {
        ...state,
        loadingPostingData: true,
        getPostingDataComplete: false,
        errorPostingData: false
      };
    case types.GET_POSTING_INFO_COMPLETED:
      return {
        ...state,
        postingData: action.payload,
        loadingPostingData: false,
        getPostingDataComplete: true
      };
    case types.GET_POSTING_INFO_FAILED:
      return {
        ...state,
        errorPostingData: isServiceError(action?.payload?.status),
        loadingPostingData: false
      };

    case types.GET_QUALITY_INFO:
      return {
        ...state,
        loadingQualityData: true,
        getPostingDataComplete: false,
        errorQualityData: false
      };
    case types.GET_QUALITY_INFO_COMPLETED:
      return {
        ...state,
        qualityData: action.payload,
        loadingQualityData: false,
        getPostingDataComplete: true
      };
    case types.GET_QUALITY_INFO_FAILED:
      return {
        ...state,
        errorQualityData: isServiceError(action?.payload?.status),
        loadingQualityData: false
      };

    case types.SET_LOADING:
      return {
        ...state,
        loadingPostingData: action.payload.needShowLoader
      };

    default:
      return state;
  }
}

export { previewReducer };
